<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>
    <div class="wrap">
      <el-form :model="formData" ref="form" :rules="rules" label-width="6rem">
        <el-row :gutter="20">
          <el-col :span="24" :xs="12">
            <el-form-item
              :label="'所属地区' + (type == 'preview' ? '：' : '')"
              :prop="type != 'preview' ? 'parentFullCodeList' : ''"
            >
              <div class="flex" v-if="type !=='preview'">
                <area-select
                  v-if="showarea && type !=='preview'"
                  v-model="formData.parentFullCodeList"
                  :data="$pcaa"
                  :level="3"
                ></area-select>
              </div>
              <span v-else>{{formData.parentFullName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" :xs="12">
            <el-form-item
              :prop="type != 'preview' ? 'name' : ''"
              :label="'村名称' + (type == 'preview' ? '：' : '')"
            >
              <el-input v-model="formData.name" placeholder="请输入" v-if="type != 'preview'"></el-input>
              <span v-else>{{ formData.name ? formData.name : '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" :xs="12">
            <el-form-item
              :prop="type != 'preview' ? 'code' : ''"
              :label="'区划代码' + (type == 'preview' ? '：' : '')"
            >
              <el-input v-model="formData.code" placeholder="请输入" v-if="type != 'preview'"></el-input>
              <span v-else>{{ formData.code ? formData.code : '-' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { regionData, CodeToText } from 'element-china-area-data'
import { saveRegion, updateRegion, getRegiontDetail } from '@/api/library/vallage'
export default {
  props: {},
  data() {
    return {
      type: '',
      showarea: false,
      selectedArea: [],
      areaOptions: regionData,
      formData: {
        parentFullCodeList: [],
        name: '',
        code: '',
        parentFullName: '',
        level: 6,
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        code: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        parentFullCodeList: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
      },
      productName: [],
      selected: [],
      clickFlag: false,
    }
  },
  watch: {
    'formData.parentFullCodeList': {
      handler(n) {
        const provinceText = this.codeToText('area', n[0], '86')
        const cityText = this.codeToText('area', n[1], n[0])
        const districtText = this.codeToText('area', n[2], n[1])
        const streetText = this.codeToText('area', n[3], n[2])
        this.formData.parentFullName = provinceText === cityText ? `${provinceText}${districtText}${streetText}` : `${provinceText}${cityText}${districtText}${streetText}`
        console.log(this.formData, ' this.formData')
      },
    },
  },
  created() {},

  methods: {
    reset() {
      this.formData = {
        parentFullCodeList: [],
        name: '',
        parentFullName: '',
        level: 6,
        code: '',
      }
      this.showarea = false
      this.resetForm('form')
    },
    add(type) {
      console.log('adddddddddd')
      this.type = type
      this.formData.parentFullCodeList = []
      this.showarea = true
    },
    getDetail(row, type) {
      this.type = type
      this.showarea = true
      this.formData = { ...row }
      console.log(this.formData, 'this.formDatathis.formDatathis.formData---------------')
      // this.formData.parentFullCodeList = row.parentFullCodeList
      // this.formData.name = row.name
      // this.formData.parentFullName = row.parentFullName
      // this.formData.level = row.level
      // this.formData.id = row.id
    },
    codeToText(fieldName, code, parentCode) {
      let name = ''
      switch (fieldName) {
        case 'area':
          for (let keyCode in this.$pcaa[parentCode]) {
            if (code == keyCode) {
              name = this.$pcaa[parentCode][keyCode]
              break
            }
          }
          return name
        case 'village':
          for (let i = 0; i < this.villageList.length; i++) {
            if (code == this.villageList[i].code) {
              name = this.villageList[i].name
              break
            }
          }
          return name
        case 'field':
          for (let i = 0; i < this.fieldList.length; i++) {
            if (code == this.fieldList[i].code) {
              name = this.fieldList[i].name
              break
            }
          }
          return name
      }
    },
    submit(type, callback) {
      if (this.clickFlag) {
        return
      }
      console.log(type, 'addddd')
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.clickFlag = true
          if (type == 'add') {
            saveRegion(this.formData)
              .then((res) => {
                this.clickFlag = false
                if (res.flag) {
                  // this.tableData = res.data.items

                  this.reset()
                  callback(true)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                this.clickFlag = false
                console.log(error)
              })
          } else if (type == 'edit') {
            updateRegion(this.formData)
              .then((res) => {
                this.clickFlag = false
                if (res.flag) {
                  // this.tableData = res.data.items

                  this.reset()
                  callback(true)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                this.clickFlag = false
                console.log(error)
              })
          }
        }
      })
    },
    handleAreaChange(value) {
      console.log(value, '------------------------------------')
      const text =
        CodeToText[value[0]] + '-' + CodeToText[value[1]] + '-' + CodeToText[value[2]] + '-' + CodeToText[value[3]]
      console.log(text, '-------------------text')
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
.wrap {
  height: 300px;
}
/deep/ .el-input--suffix .el-input__inner {
  width: 373px;
}
.left {
  margin-left: 10px;
}
/deep/ .flex {
  .el-input--suffix .el-input__inner {
    width: 127px;
  }
}
/deep/.area-select-wrap .area-select {
  margin-left: 0px;
  // margin-right: 10px;
}
// .area-select.medium

/deep/ .area-select.medium {
  width: 110px;
  height: 39px;
}
/deep/ .area-select-wrap {
  display: flex;
}
/deep/ .area-select .area-selected-trigger {
  padding: 0 0 0 10px;
}
.flex {
  display: flex;
}
.area-select {
  height: 38px;
}
</style>